import type { GridGroupNode } from "@mui/x-data-grid-premium";
import type { GroupingField, TabularGeneralSettings } from "../../../../../../../../api/types/svTypes.ts";

export const getAggregationPosition = (
  groupNode: GridGroupNode,
  showGrandTotal: boolean,
  groupSummaryPlace: TabularGeneralSettings["groupSummaryPlace"],
  groupingFields: GroupingField[]
): "footer" | "inline" | null => {
  if (groupNode.parent === null) {
    return showGrandTotal ? "footer" : null;
  }
  const group = groupingFields.find((gf) => gf.id === groupNode.groupingField);
  if (group === undefined || group.hideSummaries === true) {
    return null;
  }
  return groupSummaryPlace.localeCompare("footer", undefined, { sensitivity: "base" }) === 0 ? "footer" : "inline";
};
